import eventBus from '../../../services/eventBus'

const request = async (): Promise<{ status: 'canceled' | 'entered'; value: number }> => {
  eventBus.pub('table.items_per_page_request', {})
  return await eventBus.waitForEvent('table.items_per_page_response')
}

const tableRequestItemsPerPageService = { request }
export default tableRequestItemsPerPageService
